<template>
  <div>
    <div class="mx-6 mx-md-2 padding-res">
      <Header title="Início" />
      <div class="ml-md-8">
        <p class="text-h6 mb-2 text-left">
          Olá,
          <span class="font-weight-black"> {{ userName }}</span
          >!
        </p>
        <p class="text-body text-left">
          Com o que podemos ajudar?
        </p>
      </div>

      <!-- Module cards -->
      <div class="pa-md-8">
        <div>
          <AboutSACI />
        </div>
        <div class="py-8">
          <AboutPAAS />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
import AboutSACI from "./AboutSACI.vue";
import AboutPAAS from "./AboutPAAS.vue";

export default {
  name: "HomeScreen",
  components: {
    Header,
    AboutSACI,
    AboutPAAS,
  },
  computed: {
    userName() {
      return this.$store.getters.getUserFirstName;
    }
  },
};
</script>

<style scoped>
.main-text {
  font-size: 1.7vw;
}

.padding-res {
  padding: 30px;
}

.md-cards {
  width: 80%;
  margin: 0 auto;
}

@media only screen and (max-width: 500px) {
  .main-text {
    font-size: 5vw;
  }
  .padding-res {
    padding: 0;
  }
}

@media only screen and (min-width: 1200px) {
  .main-text {
    font-size: 1.6rem;
  }
}
</style>
